export default {
    __fullpage_hint: {
        landscape_title: '請旋轉您的螢幕',
        landscape_content: '為確保功能使用正常，且擁有最好的使用體驗，請將您的螢幕旋轉為直向，謝謝',
        understood: '了解',
    },
    __menu: {
        map: '地圖',
        table: '監控',
        table_pub: '觀測',
        product: '預報與觀測',
        background: '底圖',
        setting: '設定',
        language: 'lang',
        account: '帳號',
        about: '關於',
        previous: '舊版'
    },
    __acount: {
        account: '帳號'
    },
    __language_setting: {
        top_hint: '語言設定',
    },
    __footer: {
        about: '關於',
        how: '【怎麼用】',
        switch_lang: '【English】',
        offcial_web_link: '中央氣象署官網',
        telephone: '(02)2349-1000(代表號)',
        address: '100006 臺北市中正區公園路64號'
    },
    __navbar: {
        alert_message: '特報與即時訊息',
        logout: '登出'
    },
    __map_obs: {
        is_loading: '資料正快馬加鞭的跑來',
        top_hint: '選擇圖資',
        close_all_tree: '收合所有資料夾',
        cancel_all: '取消全選',
        show_pic_data: '顯示圖資',
        no_check_any_option_alert: '請先選擇圖資！',
    },
    __background: {
        top_hint: '選擇圖資',
        cancel_all: '取消全選',
        update_background: '顯示圖資'
    },
    __time_choose: {
        top_hint: '選擇時間',
        node_name: '圖資時間',
        update: '更新',
        select_bar_label: '選擇圖資',
        real_time: '最新資料',
        customized_search: '歷史資料查詢',
        start_date_label: '起始日期',
        start_time_label: '起始時間',
        end_time_label: '結束時間',
        display_interval_label: '顯示時段',
        back_to_date_select: '返回日期選擇',
        choose_time_warning: '選擇時間超過現在時間',
        cancel: '取消',
        decide: '確定',
    },
    __emap: {
        loading_text: '顯示中，請稍候',
        hide_legend_colorbar: '隱藏所有圖例與色標',
    },
    __product_setting: {
        title: '設定已選圖資',
        draggable_tooltip_text: '上下拖動可調整圖層順序',
        opacity: '透明度',
        map_zoom: '地圖縮放比例',
        least: '最小',
        largest: '最大',
        visible_information: '風標可見資訊',
        no_release: '目前無發布',
        fix: '測站維修中',
        no_data: '目前無資料',
        init_text: '初始',
        forecast_text: '預報',
        no_data_and_no_release: '目前無資料或未發佈'
    },
    __legend_color_bar_tool: {
        color_bar_hint: '點擊色塊可顯示或隱藏資料',
        legend_text: '圖例',
        color_bar_text:  '色標',
    },
    __timeline: {
        rewind: '向前一個區間',
        play :'開始輪播',
        pause: '暫停輪播',
        fast_forward: '向後一個區間'
    },
    __auto_update_panel: {
        tooltip: '自動更新',
    },
    __gis: {
        station: '氣象站',
        beaufort_scale: '風級',
        auto_gauge_station: '自動雨量站',
        not_exceeding_heavy_rain: '未達大雨',
        heavy_rain: '大雨',
        extremely_heavy_rain: '豪雨',
        torrential_rain: '大豪雨',
        extremely_torrential_rain: '超大豪雨',
        watch_rainfall_diagram_text: "觀看雨量時序組體圖",
        watch_weather_diagram_text: "觀看氣象時序組體圖",
        diagram: "時序圖",
    },
    __geojson: {
        typhoon_route: '路徑',
        typhoon_time: '時間',
        typhoon_animation: '輪播',
        lightning: '即時閃電',
        CG_last_3_mins: '3 分鐘內雲對地閃電',
        IC_last_3_mins: '3 分鐘內雲間閃電',
        CG_last_10_mins: '10 分鐘內雲對地閃電',
        IC_last_10_mins: '10 分鐘內雲間閃電',
        CG_last_30_mins: '30 分鐘內雲對地閃電',
        IC_last_30_mins: '30 分鐘內雲間閃電',
        typhoon_icon_text_severe:'強烈颱風',
        typhoon_icon_text_moderate:'中度颱風',
        typhoon_icon_text_mild:'輕度颱風',
        typhoon_icon_text_TD:'熱帶性低氣壓'
    },
    __search_field: {
        label: '搜尋關鍵字',
    },
    __datatable: {
        datatime: '資料時間',
        no_data_text: '目前無資料',
        no_results_text: '目前沒有找到相對應的搜尋內容',
        explanation: '參考資訊',
        download_pdf_text: '下載PDF',
        loading_text: '讀取中，請稍候...',
        no_available_data_any_time_text: '該項目目前未取得任何相關資料',
        no_available_data_in_time_text: '選取時間無資料',
        backend_response_fail_text: '項目回應有誤，請聯繫系統維護人員',
        ajax_error_text: '發生錯誤，請聯繫系統維護人員。',
        unknown_error_text: '系統回應時間過久，請稍候再試; 如重覆發生，請聯繫系統維護人員。',
        description_file_error_text: '說明文件有問題或不存在，請聯繫系統維護人員',
        capture_text: '截圖中，請稍後，資料筆數較多時，需等候較長時間',
        hint: '說明'
    },
    __monitor: {
        top_hint: '選擇表格',
        info: "資訊",
        no_data_annotaion: '-- 欄位無資料',
        min_10_gust_annotation: '⁺ 10分鐘最大瞬間風',
        hour_1_gust_annotation: '* 1小時最大瞬間風',
    },
    __rainfall: {
        rainfall: '雨量',
        default_name: '雨量觀測',
        heavy_rain: '大雨', 
        extremely_heavy_rain: '豪雨', 
        torrential_rain: '大豪雨',
        extremely_torrential_rain: '超大豪雨',
        description_head: '欄位底色： 達 ',
        description_tail: '標準',
        init_interval: '10分鐘',
        init_precp: '顯示全部',
        display_all_city: '所有縣市',
        display_all_township: '所有鄉鎮',
        city: '縣市', 
        township: '鄉鎮',
        min_10: '10分鐘',
        hour_1: '1小時',
        hour_3: '3小時',
        hour_6: '6小時',
        hour_12: '12小時',
        hour_24: '24小時',
        hour_48: '48小時',
        hour_72: '72小時',
    },
    __surface_weather: {
        default_name: '地面氣象觀測',
        display_all_city: '所有縣市',
        display_all_township: '所有鄉鎮',
        city: '縣市', 
        township: '鄉鎮',
    },
    __timeseries: {
        x_axis_label: '時間',
        y_axis_label: '降雨量(mm)',
        y_axis2_label: '累積降雨量(mm)',
        accumlated_precp_timeseries_text: '累積雨量時序組體圖',
        time_select_text: '雨量累積時間',
        legend_accumlated_precp: '累積雨量',
    },
    __chart_common: {
        station_code_key: '站號',
        day_select_text: '顯示時段',
        day_1: '1天',
        day_2: '2天',
        day_3: '3天',
        day_4: '4天',
        day_5: '5天',
        day_6: '6天',
        yaxis_max_select_text: 'Y軸上限',
        yaxis2_max_select_text: '第二Y軸上限',
        reset_time_range: '重置時間範圍',
        save_image: '儲存圖檔',
        tooltip_value: '資料值',
        tooltip_time: '資料時間',
        legend_no_data: '無資料',
        no_data: '無資料',
        back_to_gis_popup_table: '返回測站資料',
        loading_text: '讀取圖表中，請稍候',
        error_text: {
            station_code: '系統無法取得您所選取的測站圖表歷史資料',
            default: '暫時無法讀取圖表資料，請稍後嘗試，謝謝。',
        }
    },
    __monitor_weather: {
        wind_direction: '風向',
        wind_speed: '平均風',
        temperature: '溫度',
        humidity: '相對濕度',
        pressure: '氣壓',
        x_axis_label: '時間',
        wind_direction_text: '風向(°)',
        wind_speed_text: '平均風(m/s)',
        temperature_text: '溫度(°C)',
        humidity_text: '濕度(％)',
        pressure_text: '氣壓(hPa)',
        timing_diagram_text: '時序組體圖',
        legend_max: '最大',
        legend_min: '最小',
        legend_gust: '瞬間風',
        legend_wind_speed_text: '風速',
        legend_time_text: '時間',
        wind_level: '級',
        weather_variable: '氣象變數',
        gust_time: '瞬間風時間',
        gust_value: '瞬間風',
        min_10: '10分鐘',
        hour_1: '1小時',
    },
    __caputre: {
        datetime_description: '資料時間' 
    },
    __notification: {
        notification_btn_tooltip_text: '顯示警特報與公告',
        severe_weather_advisories: '警特報',
        announcements: '系統公告'
    },
    __toggle_menu_btn: {
        hint_text: '收合選單'
    },
    __favorites: {
        hint_text: '設定我的最愛',
        delete_text: '清除',
        update_text: '更新'
    }
} 